import { useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { course, enquiry } from '../../../../helper/api_url';
import { swal } from '../../../../helper/swal';
import { setPreloader } from '../../../../features/Ui/uiSlice';

export const useCreateEnquiryForm = () => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    // Fetch courses with TanStack Query
    const {
        data: courses = [],
        isLoading: isLoadingCourses,
        isError,
        error
    } = useQuery({
        queryKey: ['courses'],
        queryFn: course.list,
        staleTime: 20 * 60 * 1000,
        cacheTime: 20 * 60 * 1000,
        select: (data) =>
            data?.data?.course?.map((c) => ({
                value: c.id,
                label: c.name
            })) || []
    });

    // Single error handler (avoid duplicate execution)
    useEffect(() => {
        if (isError && error) {
            swal.error(error.response?.data?.message || error.message || 'Error fetching course list');
        }
    }, [isError, error]);

    // Mutation for adding new enquiry
    const mutation = useMutation({
        mutationFn: (formData) => enquiry.add(formData),
        onSuccess: (res) => {
            queryClient.invalidateQueries(['enquirys']);
            dispatch(setPreloader({ loader: false, message: '' }));
            swal.success(res?.data?.message || 'Enquiry added successfully!');
            navigate('/enquiry');
        },
        onError: (err) => {
            dispatch(setPreloader({ loader: false, message: '' }));
            swal.error(err.response?.data?.message || err.message || 'Failed to create enquiry');
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(setPreloader({ loader: true, message: 'Creating enquiry, please wait...' }));
        const formData = new FormData(e.target);
        mutation.mutate(formData);
    };

    return {
        courses,
        isLoadingCourses,
        isSubmitting: mutation.isPending,
        handleSubmit,
        handleCancel: () => navigate('/enquiry')
    };
};

export default useCreateEnquiryForm;
